import { FlexColumn, Button as BaseButton, Header2 } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import withPermissions from '@ubeya/shared-web/hoc/withPermissions';
import privileges from '@ubeya/shared-web/privileges';
import { AccordionSummaryContainer } from '@ubeya/shared-web/components/Accordion/Accordion';
import AddUsedPtoModal from './AddUsedPtoModal';
import PtoLogsTable from './PtoLogsTable';

const Container = styled(FlexColumn)`
  gap: 16px;
`;

const Button = styled(BaseButton)`
  background: transparent;
  &:hover,
  &:focus {
    background: transparent !important;
  }
`;

const PtoBalanceHistory = ({
  addPtoDays,
  deletePto,
  ptoData,
  employeeBranches,
  eligibleStartDate,
  activeContract,
  userPermissions: { hasActionPermission }
}) => {
  const { t } = useContext(ConfigContext);
  const [openAddUsedPtoModal, setOpenAddUsedPtoModal] = useState(false);

  return (
    <>
      <AccordionSummaryContainer>
        <Header2> {t('holidayAccrualBalanceHistory')} </Header2>
        {hasActionPermission && (
          <Button secondary narrow type="button" onClick={() => setOpenAddUsedPtoModal(true)}>
            + {t('addUsedHolidays')}
          </Button>
        )}
      </AccordionSummaryContainer>
      <Container>
        <PtoLogsTable ptoData={ptoData} onDeletePto={deletePto} hasActionPermission={hasActionPermission} />
      </Container>

      {openAddUsedPtoModal && (
        <AddUsedPtoModal
          onClose={() => setOpenAddUsedPtoModal(false)}
          addPtoDays={addPtoDays}
          employeeBranches={employeeBranches}
          eligibleStartDate={eligibleStartDate}
          activeContract={activeContract}
        />
      )}
    </>
  );
};

export default withPermissions(React.memo(PtoBalanceHistory), {
  action: { privileges: [privileges.MANAGE_EMPLOYEE_HOLIDAY_ACCRUAL] }
});
